import { createSlice } from '@reduxjs/toolkit';
import { DEVICE_TYPES } from '../../shared/constants/constants';

interface BrowserState {
  browserConfig: any;
}

const initialState = {
  browserConfig: {
    deviceType: DEVICE_TYPES.DESKTOP
  }
} as BrowserState;

export const browserSlice = createSlice({
  name: 'browser',
  initialState,
  reducers: {
    resetBrowser: () => initialState,
    setBrowserDeviceType: (state, action) => {
        state.browserConfig.deviceType = action.payload;
    },
  }
});

export const { resetBrowser, setBrowserDeviceType } = browserSlice.actions;

export default browserSlice.reducer;
